/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fileType: NonNullable<unknown> }} Editor_Select_Profile_TextInputs */

const en_editor_select_profile_text = /** @type {(inputs: Editor_Select_Profile_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Please select a profile for the ${i?.fileType} file`)
};

const fr_editor_select_profile_text = /** @type {(inputs: Editor_Select_Profile_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Veuillez selectionner un profil pour le fichier ${i?.fileType}`)
};

const de_editor_select_profile_text = /** @type {(inputs: Editor_Select_Profile_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie ein Profil für die Datei ${i?.fileType} aus.`)
};

const it_editor_select_profile_text = /** @type {(inputs: Editor_Select_Profile_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleziona un profilo per il file ${i?.fileType}`)
};

const ru_editor_select_profile_text = /** @type {(inputs: Editor_Select_Profile_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите профиль для файла ${i?.fileType}`)
};

const es_editor_select_profile_text = /** @type {(inputs: Editor_Select_Profile_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleccione un perfil para el archivo ${i?.fileType}`)
};

const zh_cn2_editor_select_profile_text = /** @type {(inputs: Editor_Select_Profile_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`请为 ${i?.fileType} 文件选择一个配置文件`)
};

const ja_editor_select_profile_text = /** @type {(inputs: Editor_Select_Profile_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fileType} ファイルのプロファイルを選択してください`)
};

const hi_editor_select_profile_text = /** @type {(inputs: Editor_Select_Profile_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कृपया ${i?.fileType} फ़ाइल के लिए एक प्रोफ़ाइल चुनें`)
};

const pt_pt2_editor_select_profile_text = /** @type {(inputs: Editor_Select_Profile_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selecione um perfil para o arquivo ${i?.fileType}`)
};

/**
* | output |
* | --- |
* | "Please select a profile for the {fileType} file" |
*
* @param {Editor_Select_Profile_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_select_profile_text = /** @type {((inputs: Editor_Select_Profile_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Select_Profile_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_select_profile_text(inputs)
	if (locale === "de") return de_editor_select_profile_text(inputs)
	if (locale === "it") return it_editor_select_profile_text(inputs)
	if (locale === "ru") return ru_editor_select_profile_text(inputs)
	if (locale === "es") return es_editor_select_profile_text(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_select_profile_text(inputs)
	if (locale === "ja") return ja_editor_select_profile_text(inputs)
	if (locale === "hi") return hi_editor_select_profile_text(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_select_profile_text(inputs)
	return en_editor_select_profile_text(inputs)
});